import { create } from "zustand";
import { DrawerProps } from "@mui/material/Drawer";
import React from "react";

export interface OpenDrawerPayload extends Omit<Partial<DrawerProps>, "content"> {
  content: React.ReactNode;
}

export interface DrawerStore extends OpenDrawerPayload {
  open: boolean;
  actions: {
    openDrawer: (payload: OpenDrawerPayload) => void;
    closeDrawer: () => void;
  };
}

const initialState: Omit<DrawerStore, "actions"> = {
  open: false,
  content: null,
};

export const useDrawerStore = create<DrawerStore>((set, get) => ({
  ...initialState,

  actions: {
    openDrawer: (payload) => {
      set(
        {
          ...initialState,
          ...payload,
          actions: get().actions,
          open: true,
        },
        true
      );
    },
    closeDrawer: () => {
      set({
        open: false,
      });
    },
  },
}));
